import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledButton = styled.div<{ small?: boolean }>`
  border-radius: 20px;
  height: ${props => (props.small ? '28px' : '40px')};
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${props => (props.small ? '12px' : '14px')};
  font-weight: 500;
  border: 1px solid black;
  margin: 20px 20px 8px 20px;
  cursor: pointer;
  width: 200px;
  &:hover {
    opacity: 0.6;
    color: white;
    background-color: black;
  }
`;

const CreateTipsButton: React.FC<{ onClick: () => void; small?: boolean }> = ({
  onClick,
  small,
}) => {
  const [t] = useTranslation();
  return (
    <StyledButton
      small={small}
      className="tips-create-button"
      onClick={onClick}
    >
      {t('tips-create')}
    </StyledButton>
  );
};

export default CreateTipsButton;
